import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['percent'])}` : '';
  const getUsageAverageConsumptionReport = `getUsageAverageConsumptionReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getUsageAverageConsumptionReport} {
        accountId
        firstName
        lastName
        provisioningId
        startDate
        endDate
        accumulatorId
        usagePeriod
        usagePeriodAmount
        usageAvgAmount
        avgLowerRangeAmount
        avgUpperRangeAmount
      }
    }
  `;
};
